export default "__VITE_ASSET__07514d33__"